import React from 'react';
import { useMediaQuery } from 'react-responsive';
import TopBar from '../../hooks/TopBar';
import OrgProfileSection from './OrganizerProfileSection';
import OrgPasswordSection from './OrganizerPasswordSection';
import OrgSecuritySection from './OrganizerSecuritySection';

const cardStyle = {
  border: '1px solid #ddd',
  background: '#fff',
  padding: '16px',
  borderRadius: '12px',
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
};

const OrgAccountLayout = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <>
      <TopBar />

      <div
        className="container-fluid py-3"
        style={{
          height: !isMobile ? 'calc(100vh - 60px)' : 'auto',
          overflowY: isMobile ? 'auto' : 'hidden',
          backgroundColor: '#FF9B45',
        }}
      >
        <div
          className={`d-flex flex-column ${!isMobile ? 'flex-md-row' : ''} gap-3`}
          style={{ height: !isMobile ? '100%' : 'auto' }}
        >
          {isMobile && (
            <div className="w-100">
              <div style={{ ...cardStyle }}>
                <OrgProfileSection />
              </div>
              <div className="mt-3" style={{ ...cardStyle }}>
                <OrgPasswordSection />
              </div>
              <div className="mt-3" style={{ ...cardStyle }}>
                <OrgSecuritySection />
              </div>
            </div>
          )}

          {!isMobile && (
            <>
              {/* Profile Section */}
              <div className="flex-grow-1" style={{ height: '100%' }}>
                <div style={{ ...cardStyle, height: '100%' }}>
                  <OrgProfileSection />
                </div>
              </div>

              {/* Password Section */}
              <div className="flex-grow-1" style={{ height: '100%' }}>
                <div style={{ ...cardStyle, height: '100%' }}>
                  <OrgPasswordSection />
                </div>
              </div>

              {/* Security Section */}
              <div className="flex-grow-1" style={{ height: '100%' }}>
                <div style={{ ...cardStyle, height: '100%' }}>
                  <OrgSecuritySection />
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default OrgAccountLayout;
